import { render, staticRenderFns } from "./CarRecord.vue?vue&type=template&id=6cea68f2&scoped=true"
import script from "./CarRecord.vue?vue&type=script&lang=js"
export * from "./CarRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cea68f2",
  null
  
)

export default component.exports